import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { requestVerificationLink } from '~/actions/verification'

// Components
import { Icon, Notifications } from '~/components'
import MiniLoader from '~/components/Loaders'
import {
    UserDropdown,
    SubNavbar
}from './components'


class Header extends React.Component {

    getLinkElement = (item) => {

        if( !item.children || item.children.length == 0) return <Link to={item.url} >{item.title}</Link>

        return <Link 	to="#"
                        className="dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
        >{item.title}</Link>

    };

    mainNav = () => {
        const { user, sessionsAllowed } = this.props.session;
        const loggedIn = !!user && 'ID' in user;
        return(
            <Fragment>
                <li className="nav-right"><a href="https://www.facebook.com/groups/StartupClubUK" target={"_blank"}>Community</a></li>
                <li className="nav-right"><Link to="/discover/" state={{fade: true}}>Discover</Link></li>
                <li className="nav-right"><Link to="/sign-up"><span>Register</span></Link></li>
            </Fragment>
        );
    }

    loginRegister = () => {
        const { user, sessionsAllowed, fetching } = this.props.session;
        if( !sessionsAllowed ) return null;
        const loggedIn = !!user && 'ID' in user;
        return (
            <React.Fragment>
                { loggedIn && <li className="nav-right"><Link to="/search"><Icon icon="search" /></Link></li> }
                { loggedIn && <Notifications /> }
                { loggedIn && <li className="nav-right nav-profile"><UserDropdown user={user} /></li> }

                { !loggedIn && !fetching.user && <li className="nav-right mright15" style={{marginLeft: 'auto'}}><Link to="/login/">Log in</Link></li> }
                {/*{ !loggedIn && !fetching.user && <li className="nav-right bg-light-main"><Link to="/register/cus_AlN59AK4ch2Tpa">Register now</Link></li> }*/}
            </React.Fragment>
        )
    }

    render() {

        const { user, fetching, sessionsAllowed } = this.props.session,
            loggedIn = !!user && 'ID' in user,
            hasSubNav = loggedIn && !user.can_pay && sessionsAllowed;

        return (
            <div>
                <nav className={"main-nav bg-white" + (hasSubNav ? ' has-sub' : '')}>
                    <div className="container">
                        <div className="row">
                            <ul className="col-xs-12">
                                <li className="nav-left navbar-logo">
                                    <Link to="/">
                                        <img src="/img/startup-club-logo.svg" className="img-responsive" alt="Startup Club logo"/>
                                        {/*<img src="/img/TownSq-landscape-logo-white.png" className="img-responsive" alt=""/>*/}
                                    </Link>
                                </li>

								{ this.mainNav() }

								{ this.loginRegister() }
                            </ul>
                        </div>
                    </div>
                </nav>

                { hasSubNav &&
                    <SubNavbar user={user} fetching={fetching.subscription} />
                }

            </div>
        )
    }
}

const mapStateToProps = state => ({
    session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({ requestVerificationLink }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/js/components/Header/index.js